import React, { useRef } from "react"
import PopperCustomMenu from "../../../../../components/Popper/PopperCustomMenu";
import MoreIcon from "../../../../../components/Icon/More";
import PencilIcon from "../../../../../components/Icon/Pencil";
import DuplicaIcon from "../../../../../components/Icon/DuplicaIcon";
import AtivaIcon from "../../../../../components/Icon/AtivaIcon";
import DesativaIcon from "../../../../../components/Icon/DesativaIcon";

export const columns = ({ functions }) => [
  {
    Header: 'Nome',
    getValue: item => item.nome,
    field: 'nome',
    props: { component: 'th', scope: 'row' },
  },
  {
    Header: 'Status',
    getValue: item => (
      <div
        style={{
          color: '#fff',
          width: 100,
          textAlign: 'center',
          backgroundColor: item.ativo ? '#26ACA9' : 'rgba(38, 172, 169, 0.5)',
          borderRadius: 50,
        }}
      >
        {item.ativo ? 'Ativo' : 'Inativo'}
      </div>
    ),
    field: 'ativo',
  },
  {
    Header: 'Ação',
    getValue: row => <PopperMenu row={row} functions={functions} />,
    props: { align: 'center' },
  },
]

const PopperMenu = ({ row, functions }) => {
  const ref = useRef(null);
  const handleCloseWithAction = (fn) => {
    return () => {
      ref?.current && ref.current.closePopper();
      fn(row.id);
    };
  };

  return (
    <PopperCustomMenu
      id={`cfg-ltg-pop-aca-${row.id}`}
      menuOpcoes={menuOpcoesPopper({
        functions: {
          handleEdit: handleCloseWithAction(functions?.handleEditar),
          handleDesativar: handleCloseWithAction(functions?.handleDesativar),
          handleAtivar: handleCloseWithAction(functions?.handleAtivar),
          handleDuplicar: handleCloseWithAction(functions?.handleDuplicar),          
        },
        desativado: !row.ativo,
        isEdit: true,
        rowId: row.id,
      })}
      ref={ref}
      iconButton={<MoreIcon color='#505050' />}
      colorButton={{
        background: '#fff',
      }}
    />
  );
};

 const menuOpcoesPopper = (options) => {
  const optionsMenu = [
    {
      id: `cfg-ltg-btn-edi-${options.rowId}`,
      ativo: options.isEdit,
      label: "Editar",
      onClick: () => options?.functions?.handleEdit(),
      icon: <PencilIcon size="12" color="#505050" />,
    },
    {
      id: `cfg-ltg-btn-dup-${options.rowId}`,
      ativo: true,
      label: "Duplicar",
      onClick: (event) => options?.functions?.handleDuplicar(),
      icon: <DuplicaIcon size="12" color="#505050" />,
    },
    {
      id: `cfg-ltg-btn-ati-${options.rowId}`,
      ativo: options.desativado,
      label: "Ativar",
      onClick: () => options?.functions?.handleAtivar(),
      icon: <AtivaIcon size="12" color="#505050" />,
    },
    {
      id: `cfg-ltg-btn-des-${options.rowId}`,
      ativo: !options.desativado,
      label: "Inativar",
      onClick: () => options?.functions?.handleDesativar(),
      icon: <DesativaIcon size="12" color="#505050" />,
    },
  ];
  return optionsMenu;
};